import { render } from "./ZhaiCardPC.vue?vue&type=template&id=7561872d&scoped=true"
import script from "./ZhaiCardPC.vue?vue&type=script&lang=js"
export * from "./ZhaiCardPC.vue?vue&type=script&lang=js"

import "./ZhaiCardPC.vue?vue&type=style&index=0&id=7561872d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7561872d"]])

export default __exports__